export enum SUBJECT {
  EMPTY = '',
  DEFAULT = 'No Subject',
}
